import { combineReducers } from 'redux';

import {
    HEART_BEAT_LOGOUT,
    LOGIN_START,
    LOGIN_ERROR,
    RESUME_LOGIN_START,
    RESUME_LOGIN_SUCCESS,
    RESUME_LOGIN_ERROR,
    IDP_LOGIN,
    LOGIN_SUCCESS
} from '../actions/auth';
import { ADD_TUTORIAL_START, ADD_TUTORIAL_SUCCESS, ADD_TUTORIAL_ERROR } from '../actions/tutorials';

function isLoggedIn(state = false, action) {
    const { type } = action;
    switch (type) {
        case RESUME_LOGIN_START:
        case RESUME_LOGIN_ERROR:
            return false;
        case RESUME_LOGIN_SUCCESS:
            return true;
        default:
            return state;
    }
}

function isResumingLogin(state = true, action) {
    const { type } = action;
    switch (type) {
        case RESUME_LOGIN_START:
            return true;
        case RESUME_LOGIN_SUCCESS:
        case RESUME_LOGIN_ERROR:
            return false;
        default:
            return state;
    }
}

function isLoggingIn(state = false, action) {
    const { type } = action;
    switch (type) {
        case LOGIN_START:
            return true;
        case LOGIN_ERROR:
            return false;
        case LOGIN_SUCCESS:
            return false;
        default:
            return state;
    }
}

function loginError(state = null, action) {
    const { type, payload } = action;
    switch (type) {
        case LOGIN_START:
            return null;
        case LOGIN_ERROR:
            return payload;
        case LOGIN_SUCCESS:
            return null;
        default:
            return state;
    }
}

export function user(state = null, action) {
    const { type, objectId, payload } = action;
    switch (type) {
        case RESUME_LOGIN_START:
        case RESUME_LOGIN_ERROR:
            return null;
        case RESUME_LOGIN_SUCCESS:
            return payload;
        case ADD_TUTORIAL_SUCCESS:
            return {
                ...state,
                alreadySeenTutorialsIds: payload
            };
        case ADD_TUTORIAL_START:
            return {
                ...state,
                ...(objectId && { objectId })
            };
        case ADD_TUTORIAL_ERROR:
        default:
            return state;
    }
}

function heartBeatLogout(state = false, action) {
    const { type } = action;
    switch (type) {
        case HEART_BEAT_LOGOUT:
            return true;
        default:
            return state;
    }
}

function persistentUserId(state = null, { type, payload }) {
    switch (type) {
        case RESUME_LOGIN_SUCCESS:
            return payload.userId;
        default:
            return state;
    }
}

function isIdpLogin(state = null, { type, isIdpLogin }) {
    switch (type) {
        case IDP_LOGIN:
            return isIdpLogin;
        default:
            return state;
    }
}

export default combineReducers({
    heartBeatLogout,
    isIdpLogin,
    isLoggedIn,
    isResumingLogin,
    isLoggingIn,
    loginError,
    user,
    persistentUserId
});
